<ng-container *ngIf="!isLoading; else loadingTemplate">



<div class="email-registration-page">
  <div class="half-circle-gradient"></div>
    <app-external-header [showButtons]="false" ></app-external-header>

  <div class="content">

    <ng-container *ngIf="isEmailPage">
      <app-layout-registration-page [imageSrc]="'assets/starten.png'" [imagePosition]="'right'"
                                    [formComponent]="emailFormComponent"></app-layout-registration-page>
    </ng-container>

    <ng-container *ngIf="isPasswordPage">
      <app-layout-registration-page  [imageSrc]="'assets/password.png'" [imagePosition]="'right'"
                                    [formComponent]="passwordFormComponent"></app-layout-registration-page>
    </ng-container>

    <ng-container *ngIf="isConsentPage">
      <app-layout-registration-page  [imageSrc]="'assets/password.png'" [imagePosition]="'right'"
                                     [formComponent]="consentFormComponent"></app-layout-registration-page>
    </ng-container>

    <ng-container *ngIf="isCodePage">
      <app-layout-registration-page [imageSrc]="'assets/punktlichkeiten.png'" [imagePosition]="'right'"
                                    [formComponent]="codeFormComponent"
                                    [formData]="user"></app-layout-registration-page>
    </ng-container>

    <ng-container *ngIf="isBioFormPage">
      <app-layout-registration-page [imageSrc]="'assets/brot.png'" [imagePosition]="'right'"
                                    [formComponent]="bioFormComponent" [formData]="id"></app-layout-registration-page>
    </ng-container>


    <ng-container *ngIf="isPersonalInformationPage">
      <app-layout-registration-page [imageSrc]="'assets/oktoberfest.png'" [imagePosition]="'right'"
                                    [formComponent]="personalInformationFormComponent"></app-layout-registration-page>
    </ng-container>

    <ng-container *ngIf="isResumeFormPage">
      <app-layout-registration-page [imageSrc]="'assets/sprache.png'" [formData]="user.profileImageUrl" [imagePosition]="'right'"
                                    [formComponent]="resumeFormComponent"></app-layout-registration-page>
    </ng-container>




    <div class="second-half-circle-gradient"></div>
    <div class="footer-class">
      <app-footer></app-footer>
    </div>
  </div>


</div>

</ng-container>
<ng-template #loadingTemplate>
  <app-load-mask></app-load-mask>
</ng-template>
